import { render, staticRenderFns } from "./CustTables.vue?vue&type=template&id=4616514d&"
import script from "./CustTables.vue?vue&type=script&lang=js&"
export * from "./CustTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports